import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Observable, Subscription, switchMap } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { CmsDestination } from '@fcom/core-api';
import { unsubscribe } from '@fcom/core/utils';
import { OndPageType, OndPairEnhancedResponse } from '@fcom/ond-marketing-landing-core/interfaces';
import { OndMarketingOffersService } from '@fcom/ond-marketing-landing-core/services';
import { getCurrentCountry } from '@fcom/ond-marketing-landing-core/services/utils';

@Component({
  selector: 'cms-ond-marketing-cross-linking',
  template: `
    @if (route.url | async; as routeSegments) {
      <fin-ond-marketing-cross-linking
        class="section-two-thirds-right col-1-12 md-col-1-9 ms-large-b"
        [route]="routeSegments"
        [links]="links$ | async"
        [ondPageType]="ondPageType"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsOndMarketingCrossLinkingComponent implements OnInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  private ondMarketingOffersService = inject(OndMarketingOffersService);
  private languageService = inject(LanguageService);

  @Input()
  content$: Observable<CmsDestination>;
  links$: Observable<OndPairEnhancedResponse>;
  ondPageType: OndPageType = OndPageType.LANDING;
  private subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.links$ = this.ondMarketingOffersService.getDestinationLocationCode(this.content$).pipe(
      switchMap((destinationLocationCode) =>
        this.ondMarketingOffersService.fetchLocationPairs({
          destination: destinationLocationCode,
          originCountry: getCurrentCountry(this.languageService.langValue),
          lang: this.languageService.langValue,
        })
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
